import clsx from 'clsx';
import React, { useMemo } from 'react';
import Styles from './NumericBullets.css';

export function NumericBullets({
  bulletCount = 0,
  currentBullet = 0,
  maxVisibleBullets = 5,
  hideBullet = false,
  onBulletClick = (v) => undefined,
}) {
  const items = useMemo(() => {
    const list = [];

    for (let i = 0; i < bulletCount; i++) {
      list.push({
        value: i,
        label: String(i + 1),
      });
    }

    return list;
  }, [bulletCount]);

  if (!bulletCount) return null;

  return (
    <>
      <div className={clsx('numeric-bullet', hideBullet && 'hidden')}>
        {items.map((item) => (
          <span
            key={`nb-${item.value}`}
            className={clsx('numeric-item', item.value === currentBullet && 'active')}
            onClick={() => {
              onBulletClick(item.value);
            }}
          >
            {item.label}
          </span>
        ))}
      </div>
      <style jsx global>
        {Styles}
      </style>
    </>
  );
}
